import {
  fetchStudentClassModule,
  fetchSubModuleTree,
  fetchSubModuleDetail,
  studentAnswerQuestion,
  studentEndSubModuleSession,
  fetchStudentWrongQuestions,
  practiceEnrollSingleItem,
  fetchPdfList,
  FETCH_PDF_LIST,
  emgInsertResultData,
} from '@store/actions/studentPracticeAction';
import {
  setLoading,
  setStudentClassModuleList,
  setSubModuleTree,
  setSubModuleDetail,
  setSesstionSubmoduleResult,
  setStudentWrongQuestionsResult,
  setPracticeEnrollSuccess,
  setPracticeEnrollLoading,
  setPdfList,
  setLoadingPdfList,
  setEmgInsertResultLoading,
  setEmgInsertResultSuccess,
  setEmgInsertResultData,
  setEmgInsertResultOutcome,
} from '@store/reducers/studentPracticeReducer';
import { toast } from 'react-toastify';
import { call, put, takeLatest } from 'redux-saga/effects';
import { resourceService } from '@libs/axios';
import { ResponseType } from '@store/index';
const API_URL = process.env.REACT_APP_API_URL;
const flattenQuestionsByType = (
  tree: any[],
  type: string
): any[] => {
  let result: any[] = [];

  tree.forEach(node => {
    if (node.sub_module_questions?.length) {
      result.push(
        ...node.sub_module_questions.filter(
          (q: any) => q.type_question === type
        )
      );
    }

    if (node.children?.length) {
      result.push(
        ...flattenQuestionsByType(node.children, type)
      );
    }
  });

  return result;
};

function* fetchStudentClassModuleSaga(action: ReturnType<typeof fetchStudentClassModule>): Generator<any, void, any> {
  try {
    yield put(setLoading(true));
    const { type } = action.payload || {};
    const params = type ? { type } : {};
    const response = yield call(resourceService.get, `/api/student_modules/`, { params })
    if (response.status === 200) {
      const list = Array.isArray(response.data) ? response.data : [];
      yield put(setStudentClassModuleList(list));
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    yield put(setLoading(false));
  }
}

function* fetchSubModuleTreeSaga(action: ReturnType<typeof fetchSubModuleTree>) {
  try {
    yield put(setSubModuleTree([]));
    yield put(setLoading(true));
    const { moduleId, classId, practice_type } = action.payload;
    let url = API_URL + `/api/student_sub_modules/?module_id=${moduleId}&class_id=${classId}`;
    if (practice_type !== undefined && practice_type !== null) {
      url += `&practice_type=${practice_type}`;
    }
    const response: ResponseType = yield call(resourceService.get, url);
    if (response.status === 200) {
      const data = Array.isArray(response.data)
        ? response.data
        : response.data != null
          ? [response.data]
          : [];
      yield put(setSubModuleTree(data));
      yield put(setLoading(false));
    }
  } catch (error) {
    yield put(setLoading(false));
    console.error(error);
  }
}

function* fetchSubModuleDetailSaga(action: ReturnType<typeof fetchSubModuleDetail>) {
  try {
    const { subModuleId, classId } = action.payload;
    yield put(setLoading(true))
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/student_sub_modules/${subModuleId}/${classId}`)
    if (response.status === 200) {
      yield put(setSubModuleDetail(response.data))
      yield put(setLoading(false))
    }
  }
  catch (error) {
    toast.error('Có lỗi xảy ra')
    yield put(setLoading(false))
  }
}
function* fetchPdfListSaga(action: ReturnType<typeof fetchSubModuleDetail>) {
  try {
    const { subModuleId, classId } = action.payload;
    yield put(setLoadingPdfList(true))
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/student_sub_modules/${subModuleId}/${classId}`)
    if (response.status === 200) {
      const pdfQuestions = flattenQuestionsByType(
  response.data.submodule_tree,
  'pdf'
);
      yield put(setPdfList(pdfQuestions))
      yield put(setLoadingPdfList(false))
    }
  }
  catch (error) {
    toast.error('Có lỗi xảy ra')
    yield put(setLoading(false))
  }
}
function* studentAnswerQuestionSaga(action: ReturnType<typeof studentAnswerQuestion>) {
  try {
    const { questionId } = action.payload;
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/student_answer_question/${questionId}/`);
    if (response.status === 200) {
      console.log('Answer question done!')
    }
  }
  catch (error) {
    console.error(error)
    toast.error('Có lỗi xảy ra, vui lòng thực hiện trả lời lại câu hỏi')
  }
}

function* studentEndSubModuleSessionSaga(action: ReturnType<typeof studentEndSubModuleSession>) {
  try {
    const { sessionId } = action.payload;
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/student_end_sub_module_sessions/${sessionId}/`)
    if (response?.status === 200) {
      yield put(setSesstionSubmoduleResult(response?.data))
    }
  }
  catch (error) {
    toast.error('Có lỗi xảy ra')
    console.error(error)
  }
}

function* studentWrongQuestionsSaga(action: ReturnType<typeof fetchStudentWrongQuestions>) {
  try {
    const { sessionId } = action.payload;
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/get_wrong_questions_by_activity/?activity_id=${sessionId}`)
    if (response?.status === 200) {
      yield put(setStudentWrongQuestionsResult(response?.data))
    }
  }
  catch (error) {
    toast.error('Có lỗi xảy ra')
    console.error(error)
  }
}

function* practiceEnrollSingleItemSaga(action: any): Generator<any, void, any> {
  yield put(setPracticeEnrollSuccess(0));
  yield put(setPracticeEnrollLoading(true));
  const { data } = action.payload;
  const payload = {
      ...data,
  };

  try {
      const response = yield call(resourceService.post, API_URL + `/api/enroll_single_endpoint/`, payload);
      if (response.status == 200) {
          // toast.success(`Thực hiện đăng ký thành công cho người dùng`);
          yield put(setPracticeEnrollSuccess(1));
          yield put(setPracticeEnrollLoading(false));
      }
  } catch (error) {
      toast.error(`Người dùng chưa được đăng ký thành công khóa học này. Hãy liên hệ giáo vụ để được hỗ trợ`);
      console.log(error);
      yield put(setPracticeEnrollSuccess(2));
      yield put(setPracticeEnrollLoading(false));
  }
}

let emgInsertResultOutcomeId = 0;

function* emgInsertResultDataSaga(action: ReturnType<typeof emgInsertResultData>): Generator<any, void, any> {
  yield put(setEmgInsertResultSuccess(0));
  yield put(setEmgInsertResultLoading(true));
  yield put(setEmgInsertResultData(null));

  const { data, meta } = action.payload;
  const outcomeId = ++emgInsertResultOutcomeId;

  const dispatchOutcome = function* (success: boolean, message?: string) {
    yield put(
      setEmgInsertResultOutcome({
        id: outcomeId,
        meta,
        success,
        message,
      }),
    );
  };

  try {
    const response = yield call(
      resourceService.post,
      API_URL + `/api/edx_insert_result_data/`,
      data,
    );

    if (response.status === 200 || response.status === 201) {
      const apiSuccess = response.data?.success !== false;
      yield put(setEmgInsertResultData(response.data));
      yield put(setEmgInsertResultSuccess(apiSuccess ? 1 : 2));
      yield* dispatchOutcome(apiSuccess, response.data?.message);
    } else {
      yield put(setEmgInsertResultSuccess(2));
      yield* dispatchOutcome(false, `HTTP ${response.status}`);
    }
  } catch (error) {
    console.error(error);
    yield put(setEmgInsertResultSuccess(2));
    yield* dispatchOutcome(false);
  } finally {
    yield put(setEmgInsertResultLoading(false));
  }
}


export default function* studentPracticeSaga() {
  yield takeLatest(fetchStudentClassModule, fetchStudentClassModuleSaga)
  yield takeLatest(fetchSubModuleTree, fetchSubModuleTreeSaga)
  yield takeLatest(fetchSubModuleDetail, fetchSubModuleDetailSaga)
  yield takeLatest(FETCH_PDF_LIST, fetchPdfListSaga)
  yield takeLatest(studentAnswerQuestion, studentAnswerQuestionSaga)
  yield takeLatest(studentEndSubModuleSession, studentEndSubModuleSessionSaga)
  yield takeLatest(fetchStudentWrongQuestions, studentWrongQuestionsSaga)
  yield takeLatest(practiceEnrollSingleItem as any, practiceEnrollSingleItemSaga)
  yield takeLatest(emgInsertResultData, emgInsertResultDataSaga)
}